import { SplideSlide } from '@splidejs/react-splide';
import clsx from 'clsx';
import { isEmpty } from 'lodash';
import { node, object, oneOfType, shape, string } from 'prop-types';

const Slide = ({ children = null, image = {}, slideClass = '' }) => {
  return (
    <SplideSlide className={clsx('relative', slideClass)}>
      {!isEmpty(image) ? (
        <>
          <img {...image} className="rounded-2xl" />
          <div className="content-over-image">{children}</div>
        </>
      ) : (
        <>{children}</>
      )}
    </SplideSlide>
  );
};

Slide.propTypes = {
  children: node,
  image: shape({
    url: string,
    alt: string
  }),
  slideClass: oneOfType([string, object])
};

export default Slide;
